import React from 'react';

import MainMenuButtom from '../MainMenuButton';
import { Wrapper } from './styles';

export const Navbar = () => {
  return (
    <Wrapper>
      <MainMenuButtom />
    </Wrapper>
  );
};
